import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { HlrRates } from '@helpers/types/models';
import { exist } from '@campaign-portal/namespace/common/id';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RatesService } from '../rates.service';

@Component({
	selector: 'app-rates-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class RatesDialogComponent {

	private readonly destroyRef = inject(DestroyRef);
		
	constructor(
				@Inject(DIALOG_DATA) public readonly data: { rate: HlrRates<exist> },
				public readonly ratesService: RatesService,
				private readonly dialogRef: DialogRef<boolean>
	) {
	}
		
	confirm(): void {
		this.ratesService.delete({ id: this.data.rate.id, startDate: this.data.rate.startDate })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp.deleted ) {
					this.dialogRef.close(true);
				}
			});
	}
		
	close(): void {
		this.dialogRef.close(false);
	}
}
